import { useEffect, useState } from "react";
import YourPartner from "../../Components/YourPartner";

const YourPartnerPage = () => {
  return (
    <>
     
      <YourPartner />
    </>
  );
};
export default YourPartnerPage;
